
export default {
  name: "ConfirmModal",
  props: {
    title: String,
    showDialog: Boolean
  }
};
